var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"stats"},[_c('li',[_vm._v(_vm._s(_vm.downloads)+"번의 다운로드")]),_c('li',[_vm._v(_vm._s(_vm.stars)+"개의 스타")]),_c('li',[_vm._v(_vm._s(_vm.contributors)+"명의 기여자")])])}
var staticRenderFns = []

export { render, staticRenderFns }